<template>
  <div>
    <!-- Table Data -->
    <div 
      v-for="(standing, SI) in standingData" 
      :key="SI" 
      class="d-flex justify-space-between px-2 py-2 table-row"
      :class="(((standing.team_id == $store.state.homeTeamID) || (standing.team_id == $store.state.awayTeamID)) && ($route.name == 'Match'))  ? 'primary--text':''"
    >
      <div class="f-13" style="min-width: 7%">
        {{standing.away.position}}.
      </div>
      <div class="f-13" style="min-width: 37%">
        {{standing.team_name}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.games_played}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.won}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.draw}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.lost}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.goals_scored}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.goals_against}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.goals_diff}}
      </div>
      <div class="f-13 text-center" style="min-width: 7%">
        {{standing.away.points}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    standingData: Array,
  },
}
</script>

<style scoped lang='sass'>
.f-13
  font-size: 13px
.table-row
  border: 1px solid #222222
  border-top: 0px !important
</style>